import React, { useRef, useState, useEffect } from "react";
import { EditProfileImage } from "../../../../components/superadmin";
import { TbTrashX } from "react-icons/tb";
import { BiCloudUpload } from "react-icons/bi";
import Modal from "react-bootstrap/Modal";
import { useFormik } from "formik";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { handleApi } from "../../../../utils/authentication";
import program from "../../../../assests/program.png";

function ProgramViewEdit({ show, setShow, program_id, setProgramId }) {
  const handleClose = () => {
    setImageUri("");
    setFile(null);
    formik.resetForm();
    setProgramId(null);
    setShow(false);
  };
  const user = useSelector((state) => state?.user);
  const [isLoading, setIsLoading] = useState(false);
  const [imageUri, setImageUri] = useState("");
  const [file, setFile] = useState(null);
  const profileImageRef = useRef(null);
  //show image showing modal
  const [editImage, setEditImage] = useState(false);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageUri(reader.result);
        setEditImage(true);
      };
      reader.readAsDataURL(file);
      setFile(file);
      event.target.value = "";
    }
  };

  //creating a program

  const handleCreateProgram = async () => {
    try {
      setIsLoading(true);
      let method = "POST";
      let headers = {};

      let formData = new FormData();
      if (imageUri && file) {
        let response = await fetch(imageUri);
        let image_file = await response?.blob();
        formData.append("program_logo", image_file, file?.name);
      }
      formData.append("program_name", formik?.values?.program_name);
      formData.append("client_id", user?.client_id);
      formData.append("created_by", user?.user_id);

      let result = await handleApi("create_program", method, headers, formData);

      if (result?.success) {
        toast.success(
          result?.data?.message
            ? result?.data?.message
            : "Program created successfully",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
        setShow(false);
        setImageUri("");
        setFile(null);
        formik.resetForm();
      } else {
        toast.error(
          result?.error?.error_message
            ? result?.error?.error_message
            : "Failed to create program",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
      }
      setIsLoading(false);
    } catch (e) {
      console.log(e);

      toast.error(e.message ? e.message : "Failed to create program", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const handleUpdateProgram = async () => {
    try {
      setIsLoading(true);
      let method = "POST";
      let headers = {};

      let formData = new FormData();
      if (imageUri && file) {
        let response = await fetch(imageUri);
        let image_file = await response?.blob();
        formData.append("program_logo", image_file, file?.name);
      }
      formData.append("program_name", formik?.values?.program_name);
      formData.append("program_id", program_id);

      let result = await handleApi("edit_program", method, headers, formData);

      if (result?.success) {
        toast.success(
          result?.data?.message
            ? result?.data?.message
            : "Program updated successfully"
        );
        setShow(false);
        setImageUri("");
        setFile(null);
        formik.resetForm();
      } else {
        toast.error(
          result?.error?.error_message
            ? result?.error?.error_message
            : "Failed to update program"
        );
      }
    } catch (e) {
      console.log(e);

      toast.error(e.message ? e.message : "Failed to update program");
    } finally {
      setIsLoading(false);
    }
  };

  const validationSchema = Yup.object({
    program_name: Yup.string().required("Program Name is Required"),
  });

  const formik = useFormik({
    initialValues: {
      program_name: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      if (program_id) {
        //updating existing program
        handleUpdateProgram();
      } else {
        //creating new program
        handleCreateProgram();
      }
    },
  });

  //getting program details
  const getProgramDetails = async () => {
    try {
      setIsLoading(true);
      let method = "POST";
      let headers = {};
      let formData = new FormData();
      formData.append("program_id", program_id);
      let result = await handleApi("view_program", method, headers, formData);
      if (result?.success) {
        formik.setValues({
          program_name: result?.data?.program_info?.program_name,
        });
        setImageUri(result?.data?.program_info?.program_logo_path);
      } else {
        toast.error(
          result?.error?.error_message
            ? result?.error?.error_message
            : "Failed to get program details"
        );
      }
    } catch (e) {
      console.log(e);

      toast.error(e.message ? e.message : "Failed to get program details");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (program_id) {
      getProgramDetails();
    }
  }, [show]);

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="program_heading">
            {" "}
            {!program_id ? "Create Program" : "Edit Program Details"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            className="rounded-pill row program_card"
            onSubmit={formik.handleSubmit}
          >
            {/* program logo */}
            <div className=" col-md-12 pb-4 d-none">
              <div className="row d-flex align-items-center ">
                <div className="col-lg-4 d-flex justify-content-center justify-content-md-start  ">
                  <img
                    src={imageUri ? imageUri : program}
                    alt="Profile"
                    style={{
                      width: "auto",
                      height: "64px",
                      borderRadius: "0.7vw",
                    }}
                  />
                  <input
                    ref={profileImageRef}
                    type="file"
                    id="profile_image"
                    className="d-none"
                    accept="image/*"
                    onChange={handleImageUpload}
                  />
                </div>
                <div className="col-lg-8 col-12  ">
                  <div className="row d-flex align-items-end justify-content-md-center">
                    <div className="col-12 col-md-12 col-lg-6 mb-2">
                      <button
                        type="button"
                        onClick={() => {
                          setImageUri("");
                          setFile(null);
                        }}
                        className={`w-100 ${
                          !imageUri && "disable_btn"
                        } btn btn-outline-custom btn-outline-primary rounded-pill d-flex justify-content-center align-items-center gap-1`}
                        disabled={!imageUri}
                      >
                        <TbTrashX /> Delete Image
                      </button>
                    </div>
                    <div className="col-12 col-md-12 col-lg-6 mb-2">
                      <button
                        type="button"
                        onClick={() => {
                          profileImageRef.current.click();
                        }}
                        className="w-100 py-2 btn btn-primary rounded-pill d-flex justify-content-center align-items-center gap-1"
                      >
                        <BiCloudUpload /> Upload Image
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className="form-group mb-2">
                <label htmlFor="program_name" className="mb-1">
                  Program name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="program_name"
                  placeholder="Enter Program Name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.program_name}
                />
                {formik.touched.program_name && formik.errors.program_name ? (
                  <div className="text-danger text-start small">
                    {formik.errors.program_name}
                  </div>
                ) : null}
              </div>
            </div>

            {(user?.role_id === 2 || user?.role_id === 1) && (
              <div className="col-12 d-flex justify-content-md-end">
                {isLoading ? (
                  <button
                    type="button"
                    disabled={isLoading}
                    className="my-3 btn btn-primary rounded-pill px-5 "
                  >
                    Loading...
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="my-3 btn btn-primary rounded-pill  px-5 "
                  >
                    Submit
                  </button>
                )}
              </div>
            )}
            <EditProfileImage
              setShow={setEditImage}
              show={editImage}
              uri={imageUri}
              setImageUri={setImageUri}
            />
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ProgramViewEdit;
